"use strict";
const matchHeight = function (equalizeByRow = true) {
    let _throttle;
    let throttleMatchHeight = () => {
        clearTimeout(_throttle);
        _throttle = window.setTimeout(() => {
            const matchElements = document.querySelectorAll(this);
            _resetHeight(matchElements);
            _setMatchedHeight(matchElements, equalizeByRow);
        }, 500);
    };
    window.addEventListener('orientationchange', throttleMatchHeight.bind(document), false);
    window.addEventListener('resize', throttleMatchHeight.bind(document), false);
    if (document.readyState === 'complete') {
        const matchElements = document.querySelectorAll(this);
        _setMatchedHeight(matchElements, equalizeByRow);
        return;
    }
    window.addEventListener('load', () => {
        const matchElements = document.querySelectorAll(this);
        _setMatchedHeight(matchElements, equalizeByRow);
    }, false);
};
function _resetHeight(matchElements) {
    Array.from(matchElements).forEach(el => {
        el.style.height = 'auto';
    });
}
function _calculateTopOffset(el) {
    return el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
}
function _setMatchedHeight(matchElements, equalizeByRow) {
    if (!equalizeByRow) {
        const elements = Array.from(matchElements);
        const maxHeight = elements.reduce((prev, current) => (prev.clientHeight > current.clientHeight) ? prev : current).clientHeight;
        elements.forEach(el => {
            el.style.height = `${maxHeight}px`;
        });
        return;
    }
    let elObject = [];
    let rowObject = [];
    Array.from(matchElements).forEach(el => {
        const offsetTop = _calculateTopOffset(el);
        if (rowObject.indexOf(offsetTop) === -1) {
            rowObject.push(offsetTop);
        }
        elObject.push({
            el: el,
            height: el.clientHeight,
            offsetTop: offsetTop
        });
    });
    rowObject.forEach(r => {
        const rowElements = elObject.filter(e => e.offsetTop === r);
        const maxHeight = rowElements.reduce((prev, current) => (prev.height > current.height) ? prev : current).height;
        rowElements.forEach(e => {
            e.el.style.height = `${maxHeight}px`;
        });
    });
}
String.prototype.matchHeight = matchHeight;
